import { ForgotPasswordStep } from './interfaces';
import { createProxy } from '../../toolkit/proxy';
import { EIdentifierType } from '@frontegg/rest-api';
export const initialState = {
  step: ForgotPasswordStep.forgotPassword,
  loading: false,
  identifier: '',
  identifierType: EIdentifierType.email,
  sessionId: '',
  userId: '',
  token: '',
  passwordConfig: null
};
export default (overrideState => createProxy(initialState, overrideState));